import { Establecimientos } from "src/app/models";
import {makeBusinessEntity, PartialBusinessEntityOptions} from "../../../../lib/libby/generator";
import { businessOptions } from "../../businessOptions";

const DAO_NAME = 'establecimiento';

const defaultOptions: PartialBusinessEntityOptions<any> = {
  hoc: {
    withAccordionSelector: {
      idKey: 'idestablecimiento',
      labelKey: 'descripcion',
    },
    withSelectedChips: {
      idKey: 'idestablecimiento',
      labelKey: 'descripcion',
    },
  },
};

const optionsToUse = !businessOptions.Establishment ? defaultOptions : {
  ...defaultOptions,
  ...businessOptions.Establishment,
  hoc: { ...defaultOptions.hoc, ...businessOptions.Establishment.hoc }
};

const {
  hook: { fetchById, libbyCall, libbyDAO, libbyFetch },
  hoc: { renderPropCall, renderPropFetchById, simpleSelect, accordionSelector, selectedChips },
  context: {
    byIdContext: { useByIdContext, ByIdProvider, ByIdContext },
    generalContext: { useGeneralContext, GeneralProvider, GeneralContext },
  },
} = makeBusinessEntity<Establecimientos>(DAO_NAME, optionsToUse);

// hooks
export const useEstablishmentFetchById = fetchById;
export const useEstablishmentLibbyCall = libbyCall;
export const useEstablishmentDAO = libbyDAO;
export const useEstablishmentLibbyFetch = libbyFetch;

// components/hoc
export const EstablishmentCall = renderPropCall;
export const EstablishmentById = renderPropFetchById;
export const EstablishmentSelect = simpleSelect;
export const EstablishmentAccordionSelector = accordionSelector;
export const EstablishmentSelectedChips = selectedChips;

// context
// ByIdContext
export const useEstablishmentByIdContext = useByIdContext;
export const EstablishmentByIdProvider = ByIdProvider;
export const EstablishmentByIdContext = ByIdContext;
// GeneralContext
export const useEstablishmentContext = useGeneralContext;
export const EstablishmentProvider = GeneralProvider;
export const EstablishmentContext = GeneralContext;
